import { Icon } from '@chakra-ui/react'
import Pencil from '../../../components/Icon/Pencil'
import Colors from '../../../config/colors'
import useAgency from './useAgency'
import Agency from '../../../models/agency'

export default function Edition({ agency }: { agency: Agency }) {
    const openModal = useAgency(agency)

    return (
        <Icon
            fill={Colors.INFO}
            as={Pencil}
            marginRight={2}
            cursor="pointer"
            onClick={openModal}
        />
    )
}
